import { graphql } from "./generated/gql";

export const ScheduleConfigQuery = graphql(`
  query ScheduleConfig($scheduleConfigId: ID!) {
    scheduleConfig(scheduleConfigId: $scheduleConfigId) {
      scheduleConfigId
      termId
      durationMinutes
      workingHoursStart
      workingHoursEnd
      scheduleTitle
      scheduleDescription
      deadlineDate
      reminderEnabled
      reminderOneWeekBefore
      reminderOneDayBefore
      zoomHostEmail
      availableFromDays
      availableUntilDays
      slotDisplayStartDate
      slotDisplayEndDate
      replyToEmail
      useCase
      createdAt
      updatedAt
    }
  }
`);

export const TermScheduleConfigQuery = graphql(`
  query TermScheduleConfig($termId: ID!) {
    termScheduleConfig(termId: $termId) {
      scheduleConfigId
      termId
      durationMinutes
      workingHoursStart
      workingHoursEnd
      scheduleTitle
      scheduleDescription
      deadlineDate
      reminderEnabled
      reminderOneWeekBefore
      reminderOneDayBefore
      zoomHostEmail
      availableFromDays
      availableUntilDays
      slotDisplayStartDate
      slotDisplayEndDate
      replyToEmail
      useCase
      createdAt
      updatedAt
    }
  }
`);

export const CreateScheduleConfigMutation = graphql(`
  mutation CreateScheduleConfig($input: CreateScheduleConfigInput!) {
    createScheduleConfig(input: $input) {
      scheduleConfigId
      termId
      durationMinutes
      workingHoursStart
      workingHoursEnd
      scheduleTitle
      scheduleDescription
      deadlineDate
      reminderEnabled
      reminderOneWeekBefore
      reminderOneDayBefore
      zoomHostEmail
      availableFromDays
      availableUntilDays
      slotDisplayStartDate
      slotDisplayEndDate
      replyToEmail
      useCase
      createdAt
      updatedAt
    }
  }
`);

export const UpdateScheduleConfigMutation = graphql(`
  mutation UpdateScheduleConfig($input: UpdateScheduleConfigInput!) {
    updateScheduleConfig(input: $input) {
      scheduleConfigId
      termId
      durationMinutes
      workingHoursStart
      workingHoursEnd
      scheduleTitle
      scheduleDescription
      deadlineDate
      reminderEnabled
      reminderOneWeekBefore
      reminderOneDayBefore
      zoomHostEmail
      availableFromDays
      availableUntilDays
      slotDisplayStartDate
      slotDisplayEndDate
      replyToEmail
      useCase
      createdAt
      updatedAt
    }
  }
`);
